import React from 'react';
import { MerchantWarehouseContextProvider } from '../../context';
import MerchantWarehouseScreenview from './MerchantWarehouseScreenview';

export default function MerchantWarehouseView() {
    return (
        <MerchantWarehouseContextProvider>
            <MerchantWarehouseScreenview />
        </MerchantWarehouseContextProvider>
    );
}
